import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {Artist} from '../../model/Artist';
import {ImageService} from '../../service/ImageService';
import {MusicCollectionService} from '../../service/MusicCollectionService';
import {AlbumSummary} from '../../model/AlbumSummary';
import {AlbumSummaryCollection} from '../../model/AlbumSummaryCollection';
import {ArtistNavigationService} from '../../service/ArtistNavigationService';
import {MusicCollectionSettingsService} from '../../service/MusicCollectionSettingsService';
import {ParagraphTextRenderingService} from '../../service/ParagraphTextRenderingService';

@Component({
  selector: 'app-artist',
  templateUrl: './artist.component.html',
  styleUrls: ['./artist.component.scss']
})
export class ArtistComponent implements OnInit {

  albumView: string = MusicCollectionSettingsService.CARD;
  artistSortForNavigation: string = MusicCollectionSettingsService.ARTIST_SORT_ALPHABETICAL;
  artist: Artist;
  albums: AlbumSummaryCollection;
  averageStarRating: string;
  placeToStart: AlbumSummary[];

  constructor(
    private route: ActivatedRoute,
    private musicCollectionService: MusicCollectionService,
    private imageService: ImageService,
    private artistNavigationService: ArtistNavigationService,
    private musicCollectionSettingsService: MusicCollectionSettingsService,
    private paragraphTextRenderingService: ParagraphTextRenderingService
  ) {
    this.placeToStart = new Array<AlbumSummary>();
  }

  ngOnInit(): void {
    console.log('in ArtistComponent.ngOnInit()');
    // this component is reused when we navigate between artists,
    // so we register to be notified anytime params change.
    this.route.paramMap.subscribe(params => this.handleParamsChange(params));
    this.initializeAlbumView();
  }

  handleParamsChange(params: ParamMap): void {
    this.artist = null;
    this.albums = null;
    this.getArtist();
    this.getAlbums();
  }

  initializeAlbumView(): void {
    this.albumView = this.musicCollectionSettingsService.getAlbumViewFromLocalStorage(MusicCollectionSettingsService.CARD);
  }

  getArtist(): void {
    const id = this.route.snapshot.paramMap.get('artistId');
    this.musicCollectionService.getArtist(id)
      .subscribe(artist => this.artist = artist);
  }

  getAlbums(): void {
    const id = this.route.snapshot.paramMap.get('artistId');
    this.musicCollectionService.getAlbumsForArtist(id)
      .subscribe(albums => this.processAlbums(albums));
  }

  processAlbums(albums: Array<AlbumSummary>): void {
    this.albums = new AlbumSummaryCollection();
    this.albums.deserializeAlbums(albums);
    this.calculateAverageStarRating(this.albums);
    this.calculatePlaceToStart(this.albums);
  }

  calculateAverageStarRating(albums: AlbumSummaryCollection): void {
    let totalRating = 0.0;
    for (const album of albums.albumSummaries) {
      totalRating += album.rating;
    }
    this.averageStarRating = (totalRating / albums.albumSummaries.length).toFixed(2);
  }

  calculatePlaceToStart(albums: AlbumSummaryCollection): void {
    // first clear array on route change
    this.placeToStart.length = 0;
    for (const album of albums.albumSummaries) {
      if (album.isPlaceToStart()) {
        this.placeToStart.push(album);
      }
    }
  }

  getArtistImg(artistId: string): string {
    return this.imageService.getArtistImg(artistId);
  }

  albumViewIsCard(): boolean {
    return this.albumView === MusicCollectionSettingsService.CARD;
  }

  albumViewIsTable(): boolean {
    return this.albumView === MusicCollectionSettingsService.TABLE;
  }

  viewCards(): void {
    console.log('Switching to card view');
    this.albumView = MusicCollectionSettingsService.CARD;
    this.musicCollectionSettingsService.storeAlbumViewInLocalStorage(this.albumView);
  }

  viewTable(): void {
    console.log('Switching to table view');
    this.albumView = MusicCollectionSettingsService.TABLE;
    this.musicCollectionSettingsService.storeAlbumViewInLocalStorage(this.albumView);
  }

  getArtistDescription(rawDescription: string): string {
    if (!rawDescription) {
      return rawDescription;
    }
    return this.paragraphTextRenderingService.getRenderedText(rawDescription, this.artist.id);
  }

}
